import { FeatureCategory } from '../types';

export const healthMonitoringFeatures: FeatureCategory = {
  name: "Health & Wellness Monitoring",
  icon: "Heart",
  features: [
    { 
      name: "Health Tracking", 
      description: "Comprehensive health metrics tracking including vital signs, weight, and key health indicators over time.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Wellness Log",
      description: "Track daily wellness indicators, symptoms, and overall health status with easy-to-use logging tools.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Symptoms Tracking",
      description: "Monitor and track symptoms over time to identify patterns and share with healthcare providers.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Sleep & Mood Monitoring",
      description: "Track sleep patterns, quality, and mood changes to understand their impact on overall wellness.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Medication Tracking",
      description: "Track medications, set reminders, and monitor adherence with easy-to-use medication management tools.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "FDA Medication Integration",
      description: "Access FDA medication database for drug information, interactions, and safety alerts.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Pharmacy Finder",
      description: "Locate nearby pharmacies and compare prescription prices across different providers.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Cannabis Finder",
      description: "Find licensed cannabis dispensaries and products for medical use where legally available.",
      starter: ", ", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "My Doctor Visits",
      description: "Your personal notebook for doctor visits, capture what the doctor said, what you need to do next, and keep a reliable record you can share with family.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    },
    {
      name: "Health Info Finder",
      description: "Access reliable health information and resources from trusted medical sources.",
      starter: "✔", max: "✔", family: "✔", careAddOn: "✔"
    }
  ]
};
